/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router';
import appReducer from './app-reducer';
import currencyReducer from './currency-reducer';
import saveBarReducer from './save-bar-reducer';
import dataBlog from './blog-reducer';
import translationReducer from './translation-reducer';
import overviewReducer from './overview-reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    appReducer,
    currencyReducer,
    dataBlog,
    saveBarReducer,
    translationReducer,
    overviewReducer
  });
